import styled from 'styled-components'

const LoginPopupStyle = styled.div.attrs(( props ) => ({ className: props.className }))`
  width: 100%;

  .login {
    width: var(--sp52x);
    background-color: var(--white);
    border-radius: 20px;
    position: relative;
    padding: var(--sp5x);
    margin-top: var(--sp10x);
    margin-bottom: var(--sp10x);

    .op-close {
      position: absolute;
      top: var(--sp5x);
      right: var(--sp5x);
    }

    .title {
      margin-bottom: var(--sp3x);
    }

    .input-text {
      margin-bottom: var(--sp2x);
    }

    .ant-form-item {
      margin-bottom: 0;
    }

    .soc-icon {
      width: 20px;
      height: 20px;
      margin-right: var(--sp3x);

      img {
        object-fit: contain;
      }
    }

    .or {
      position: relative;
      margin-bottom: var(--sp2x);
      display: flex;
      justify-content: center;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: calc(50% - 20px);
        height: 1px;
        background-color: var(--lightGrey);
      }

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        width: calc(50% - 20px);
        height: 1px;
        background-color: var(--lightGrey);
      }

      .comp-title {
        font-size: 14px;
        align-self: center;
      }
    }

    .have-account {
      display: inline-block;
      margin-top:var(--sp2x);
    }
    
    .forgot {
      font-size: 14px;
    }

    .login-btn {
      align-self: flex-start;
      margin-top: var(--sp4x);
    }

    .sign {
      width: 100%;

      .sign-up-btn {
        width: 100%;
      }
    }
  }

  @media only screen and (max-width: ${ ( props ) => props.theme.mediaQuery.MobileSize }) {
    height: 100%;
    justify-content:center;
    
    .login {
      max-width: unset;
      width: calc(100% - var(--sp4x));
      padding: var(--sp2-5x);

      .op-close {
        top: var(--sp3x);
        right: var(--sp2-5x);
      }

      .soc-icon {
        margin-right: var(--sp2x);
      }
    }
  }
`
export default LoginPopupStyle
